export const FORM_STATUS_LABELS = {
  pending: 'Ожидает заполнения',
  submitted: 'Заполнен',
  expired: 'Завершён',
  discussed: 'Обсуждён',
};

export const FORM_STATUS_COLORS = {
  pending: 'default',
  submitted: 'processing',
  expired: 'warning',
  discussed: 'success',
};

export const MOOD_EMOJIS = {
  1: '😞',
  2: '😟',
  3: '😕',
  4: '😐',
  5: '🙂',
  6: '😊',
  7: '😄',
  8: '😁',
  9: '🤩',
  10: '🚀',
};

export const getMoodEmoji = (score) => MOOD_EMOJIS[score] || '🙂';

export const STATE_WORDS = [
  'воодушевление',
  'уверенность',
  'спокойствие',
  'удовлетворенность',
  'мотивация',
  'интерес',
  'энергичность',
  'сосредоточенность',
  'оптимизм',
  'стабильность',
  'выжидание',
  'неопределенность',
  'усталость',
  'перегруженность',
  'напряжение',
  'стресс',
  'раздражение',
  'растерянность',
  'демотивация',
  'тревога',
  'выгорание',
  'разочарование',
];

export const PROUD_RESULTS = {
  important_task: 'Завершил(а) важную задачу/проект',
  all_tasks_on_time: 'Выполнил(а) все запланированные задачи в срок',
  solved_problem: 'Решил(а) сложную проблему',
  improved_process: 'Улучшил(а) рабочий процесс',
  positive_feedback: 'Получил(а) положительную обратную связь от коллег',
  new_tool: 'Освоил(а) новый инструмент',
  no_result: 'Пока не могу выделить конкретный результат',
};

export const WENT_WELL = {
  planning: 'Планирование работы',
  deadlines: 'Соблюдение сроков',
  communication: 'Коммуникация с коллегами',
  quality: 'Качество выполненных задач',
  non_standard: 'Решение нестандартных задач',
  independence: 'Самостоятельность в принятии решений',
  teamwork: 'Работа в команде',
  time_management: 'Организация своего времени',
  other: 'Другое',
};

export const DIFFICULTIES = {
  high_load: 'Высокая нагрузка',
  lack_of_time: 'Нехватка времени',
  unclear_requirements: 'Неясные требования к задаче',
  technical: 'Технические сложности',
  lack_of_info: 'Недостаток информации',
  dependency: 'Зависимость от других коллег',
  priority_changes: 'Частые изменения приоритетов',
  communication: 'Сложности в коммуникации',
  none: 'Трудностей не возникало',
  other: 'Другое',
};

export const HELPS_EFFECTIVE = {
  clear_tasks: 'Чётко поставленные задачи',
  clear_priorities: 'Понятные приоритеты',
  manager_support: 'Поддержка руководителя',
  colleague_help: 'Помощь коллег',
  independence: 'Самостоятельность в принятии решений',
  team_communication: 'Хорошая коммуникация в команде',
  enough_time: 'Достаточное количество времени на задачи',
  good_tools: 'Удобные рабочие инструменты',
  automation: 'Автоматизация процессов',
  feedback: 'Регулярная обратная связь',
  none: 'Ничего из перечисленного',
  other: 'Другое',
};

export const HINDERS_WORK = {
  high_load: 'Высокая рабочая нагрузка',
  priority_changes: 'Частая смена приоритетов',
  lack_of_info: 'Недостаток информации для выполнения задач',
  unclear_requirements: 'Неясные требования к задачам',
  urgent_tasks: 'Слишком много срочных задач',
  approvals_wait: 'Длительное ожидание согласований',
  dependency: 'Зависимость от других коллег/команд',
  many_meetings: 'Большое количество встреч',
  lack_of_feedback: 'Недостаток обратной связи',
  lack_of_resources: 'Недостаток ресурсов (людей, времени и т.д.)',
  nothing: 'Ничего не мешает',
  other: 'Другое',
};

export const COLLEAGUE_DIFFICULTIES = {
  no: 'Нет',
  minor: 'Да, незначительные',
  significant: 'Да, существенные',
};

export const COLLEAGUE_ISSUES = {
  poor_communication: 'Недостаточная коммуникация',
  slow_responses: 'Долгое ожидание ответов',
  unclear_responsibility: 'Неясное распределение ответственности',
  inconsistency: 'Несогласованность действий',
  different_priorities: 'Разные приоритеты',
  conflict_of_interest: 'Конфликт интересов',
  lack_of_info: 'Недостаток информации',
  incompetence: 'Некомпетентность',
  negative_tone: 'Негативный эмоциональный фон',
  other: 'Другое',
};

export const PROCESSES_TO_IMPROVE = {
  task_setting: 'Постановка задач',
  work_planning: 'Планирование работы',
  prioritization: 'Приоритизация задач',
  team_communication: 'Коммуникация внутри команды',
  decision_approval: 'Согласование решений',
  regular_meetings: 'Регулярные встречи',
  onboarding: 'Онбординг новых сотрудников',
  knowledge_sharing: 'Обмен знаниями внутри команды',
  tools: 'Используемые инструменты и сервисы',
  other: 'Другое',
};

export const RECENT_LEARNING = {
  new_tool: 'Освоил(а) новый инструмент',
  new_process: 'Изучил(а) новый рабочий процесс',
  professional_knowledge: 'Улучшил(а) профессиональные знания в своей области',
  communication_skills: 'Развил(а) навыки коммуникации',
  planning_skills: 'Улучшил(а) навыки планирования и организации работы',
  prioritization_skills: 'Научился(ась) эффективнее расставлять приоритеты',
  colleague_interaction: 'Получил(а) новый опыт взаимодействия с коллегами',
  new_task: 'Попробовал(а) выполнить новую для себя задачу',
  no_opportunity: 'Не было возможности освоить что-то новое',
  other: 'Другое',
};

export const DEVELOPMENT_SUPPORT = {
  internal_training: 'Внутреннее обучение',
  mentorship: 'Наставничество',
  regular_feedback: 'Регулярная обратная связь',
  harder_tasks: 'Более сложные задачи',
  experience_exchange: 'Возможность обмена опытом с коллегами',
  new_projects: 'Участие в новых проектах',
  more_time: 'Больше времени на погружение',
  no_support_needed: 'Дополнительная поддержка не требуется',
  other: 'Другое',
};

export const DISCUSSION_TOPICS = {
  tasks_priorities: 'Текущие задачи и приоритеты',
  workload: 'Рабочая нагрузка',
  deadlines: 'Сроки выполнения задач',
  feedback_on_work: 'Получение обратной связи по моей работе',
  difficulties: 'Возникшие сложности и препятствия',
  cross_team: 'Взаимодействие с коллегами или другими командами',
  processes: 'Рабочие процессы',
  career: 'Карьерное развитие',
  new_tasks: 'Новые задачи',
  responsibility: 'Распределение ответственности',
  personal: 'Личные вопросы, влияющие на работу',
  other: 'Другое',
};

export const FEEDBACK_NEEDED = {
  work_quality: 'Качество моей работы',
  current_tasks: 'Выполнение текущих задач',
  efficiency: 'Эффективность работы',
  communication: 'Коммуникация с коллегами',
  teamwork: 'Работа в команде',
  independence: 'Самостоятельность в работе',
  time_management: 'Управление временем',
  professional_growth: 'Профессиональное развитие',
  leadership: 'Лидерские качества',
  not_needed: 'Пока обратная связь не требуется',
  other: 'Другое',
};

export const MANAGER_FEEDBACK = {
  process_improvements: 'Есть предложения по улучшению процессов',
  more_feedback: 'Нужна более регулярная обратная связь',
  discuss_development: 'Хотелось бы более часто обсуждать развитие',
  team_interaction_ideas: 'Есть идеи по улучшению взаимодействия в команде',
  no_feedback: 'Пока обратной связи нет',
  other: 'Другое',
};

export const MEETING_MAIN_RESULT = {
  answers: 'Получить ответы на мои вопросы',
  feedback: 'Получить обратную связь',
  solve_problem: 'Найти решение текущей проблемы',
  next_steps: 'Определить дальнейшие шаги',
  career_goals: 'Обсудить развитие и карьерные цели',
  adjust_priorities: 'Скорректировать приоритеты',
  regular_sync: 'Просто провести регулярную синхронизацию',
  other: 'Другое',
};

export const toSelectOptions = (map) =>
  Object.entries(map).map(([value, label]) => ({ value, label }));

export const labelsFromKeys = (keys, map) =>
  (keys || []).map((k) => map[k] || k).join(', ');
